<template>
  <div/>
</template>
<script>
export default {
  created () {
    console.warn('APP VER', '2019年 10月28日 月曜日 13時24分10秒 JST')
  }
}
</script>



// WEBPACK FOOTER //
// src/version.vue